import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translations
import enTranslation from "./en/translation.json";
import frTranslation from "./fr/translation.json";

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      fr: {
        translation: frTranslation,
      },
    },
    lng: "fr", // Default language (will be overridden by Redux)
    fallbackLng: "fr",
    debug: process.env.NODE_ENV === "development",

    // Désactiver la détection automatique car Redux gère maintenant la persistance
    detection: {
      order: [],
      caches: [],
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
